// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniMyAccountStyles } from "@conklin/App/Components/MiniMyAccount/MiniMyAccount";
import IconChange from "@conklin/XDL/Icons/IconChange";
import IconSignout from "@conklin/XDL/Icons/IconSignout";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, createLinkIconStyles } from "@conklin/XDL/Utilities";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const sharedSectionTitleStyle: TypographyPresentationProps = {
    size: 14,
    lineHeight: "17px",
    weight: fontConfig.weight.bold,
    css: css`
        flex-basis: 100%;
        margin-bottom: 8px;
        display: block;
    `,
};

miniMyAccountStyles.titleWrapper = {
    css: css`
        align-items: center;
        display: flex;
        justify-content: space-between;
        padding: 8px 12px;
        margin-bottom: 12px;
        background-color: ${color("primary")};
    `,
};

miniMyAccountStyles.title = {
    variant: "h4",
    color: "common.ui1",
    css: css`
        margin-bottom: 0;
        width: 100%;
    `,
};

miniMyAccountStyles.linkItems = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            padding: 0 12px;
            margin-bottom: 12px;
        `,
    },
    title: sharedSectionTitleStyle,
    link: {
        typographyProps: {
            size: 12,
            weight: fontConfig.weight.bold,
            lineHeight: "15px",
            css: css`
                letter-spacing: 0;
                margin-bottom: 0;
            `,
        },
    },
    linkWrapper: {
        css: css`
            flex-basis: calc(50% - 12px);
            margin-bottom: 8px;
        `,
    },
};

miniMyAccountStyles.personalInfo = {
    wrapper: {
        css: css`
            padding: 0 12px;
            display: flex;
            column-gap: 16px;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-bottom: 12px;
        `,
    },
    infoWrapper: {
        css: css`
            flex: 0 0 calc(50% - 8px);
        `,
    },
    title: sharedSectionTitleStyle,
    subTitle: {
        size: 12,
        lineHeight: "15px",
        weight: fontConfig.weight.bold,
        css: css`
            display: block;
            margin-bottom: 4px;
        `,
    },
    shipToInfo: {
        size: 12,
        weight: fontConfig.weight.regular,
        lineHeight: "15px",
        css: css`
            display: block;
            width: 100%;
        `,
    },
    pickUpInfo: {
        size: 12,
        weight: fontConfig.weight.regular,
        lineHeight: "15px",
        css: css`
            display: block;
            width: 100%;
        `,
    },
};

miniMyAccountStyles.actionSection = {
    wrapper: {
        css: css`
            border-top: 1px solid ${color("common.border")};
            padding: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
        `,
    },
    changeFulfillmentButton: {
        ...createLinkIconStyles(IconChange, "small", "left"),
    },
    signOutButton: {
        ...createLinkIconStyles(IconSignout, "small", "left", false, {
            css: css`
                margin-left: auto;
            `,
        }),
    },
};
